import React, { useState, useEffect, useCallback, useRef } from 'react';
import { io } from 'socket.io-client';

// ===== 스타일 =====
const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
    padding: '20px',
    maxWidth: '600px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    color: '#e6e6e6',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  header: {
    textAlign: 'center',
    padding: '16px 0',
  },
  logo: {
    fontSize: '32px',
    fontWeight: '900',
    background: 'linear-gradient(135deg, #00d4aa, #00a896)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    marginBottom: '4px',
  },
  subtitle: {
    fontSize: '13px',
    color: '#8892b0',
  },
  card: {
    background: 'rgba(255,255,255,0.05)',
    borderRadius: '16px',
    padding: '20px',
    border: '1px solid rgba(255,255,255,0.1)',
  },
  statusCard: {
    background: 'rgba(255,255,255,0.05)',
    borderRadius: '16px',
    padding: '24px',
    textAlign: 'center',
    border: '1px solid rgba(255,255,255,0.1)',
  },
  statusBadge: (isRunning) => ({
    display: 'inline-block',
    padding: '8px 24px',
    borderRadius: '30px',
    fontSize: '14px',
    fontWeight: '700',
    background: isRunning ? 'rgba(255,107,107,0.2)' : 'rgba(0,212,170,0.2)',
    color: isRunning ? '#ff6b6b' : '#00d4aa',
  }),
  runningInfo: {
    marginTop: '12px',
    fontSize: '16px',
    color: '#ccd6f6',
  },
  timerCard: {
    background: 'linear-gradient(145deg, rgba(0,212,170,0.15), rgba(0,212,170,0.05))',
    borderRadius: '20px',
    padding: '32px 20px',
    textAlign: 'center',
    border: '2px solid rgba(0,212,170,0.3)',
  },
  timerLabel: {
    fontSize: '14px',
    color: '#8892b0',
    marginBottom: '8px',
  },
  timer: {
    fontSize: '64px',
    fontWeight: '900',
    color: '#00d4aa',
    fontFamily: '"SF Mono", Monaco, monospace',
    letterSpacing: '4px',
    textShadow: '0 0 40px rgba(0,212,170,0.5)',
  },
  cancelBtn: {
    marginTop: '20px',
    padding: '14px 32px',
    borderRadius: '12px',
    border: 'none',
    fontSize: '15px',
    fontWeight: '700',
    cursor: 'pointer',
    background: 'linear-gradient(135deg, #ff6b6b, #ee5253)',
    color: '#fff',
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
  queueCard: {
    background: 'rgba(255,255,255,0.05)',
    borderRadius: '16px',
    padding: '16px 20px',
    border: '1px solid rgba(255,255,255,0.1)',
  },
  queueHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  queueTitle: {
    fontSize: '15px',
    fontWeight: '700',
    color: '#e6e6e6',
  },
  queueCount: {
    fontSize: '13px',
    color: '#8892b0',
  },
  queueGrid: {
    display: 'flex',
    justifyContent: 'space-around',
    textAlign: 'center',
  },
  queueItem: {
    flex: 1,
  },
  queueLabel: {
    fontSize: '12px',
    color: '#8892b0',
    marginBottom: '4px',
  },
  queueValue: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#00d4aa',
  },
  myTicketCard: {
    background: 'linear-gradient(145deg, rgba(255,193,7,0.2), rgba(255,193,7,0.1))',
    borderRadius: '16px',
    padding: '20px',
    textAlign: 'center',
    border: '2px solid rgba(255,193,7,0.4)',
  },
  myTicketLabel: {
    fontSize: '13px',
    color: '#ffc107',
    marginBottom: '8px',
  },
  myTicketNumber: {
    fontSize: '56px',
    fontWeight: '900',
    color: '#ffc107',
    textShadow: '0 0 20px rgba(255,193,7,0.3)',
  },
  myTicketHint: {
    marginTop: '8px',
    fontSize: '14px',
    color: '#00d4aa',
    fontWeight: '600',
  },
  queueTimeoutTimer: {
    fontSize: '16px',
    color: '#ffc107',
    marginTop: '8px',
    fontWeight: '700',
    textAlign: 'center',
    padding: '8px',
    background: 'rgba(255, 193, 7, 0.1)',
    borderRadius: '8px',
    border: '1px solid rgba(255, 193, 7, 0.3)',
  },
  turnNotice: {
    background: 'linear-gradient(145deg, rgba(0,212,170,0.25), rgba(0,212,170,0.1))',
    borderRadius: '16px',
    padding: '20px',
    textAlign: 'center',
    border: '2px solid #00d4aa',
    animation: 'pulse 2s infinite',
  },
  turnNoticeText: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#00d4aa',
    lineHeight: 1.6,
  },
  modeSection: {
    background: 'rgba(255,255,255,0.05)',
    borderRadius: '16px',
    padding: '20px',
    border: '1px solid rgba(255,255,255,0.1)',
  },
  sectionTitle: {
    fontSize: '15px',
    fontWeight: '700',
    color: '#e6e6e6',
    marginBottom: '16px',
  },
  postureTabs: {
    display: 'flex',
    gap: '10px',
    marginBottom: '16px',
  },
  postureTab: (active) => ({
    flex: 1,
    padding: '14px',
    borderRadius: '12px',
    border: 'none',
    fontSize: '15px',
    fontWeight: '700',
    cursor: 'pointer',
    transition: 'all 0.2s',
    background: active ? '#00d4aa' : 'rgba(255,255,255,0.1)',
    color: active ? '#1a1a2e' : '#8892b0',
  }),
  modeList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  modeItem: (selected) => ({
    padding: '14px 16px',
    borderRadius: '10px',
    border: selected ? '2px solid #00d4aa' : '1px solid rgba(255,255,255,0.1)',
    background: selected ? 'rgba(0,212,170,0.1)' : 'rgba(255,255,255,0.03)',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    transition: 'all 0.2s',
  }),
  modeName: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#e6e6e6',
  },
  modeDuration: {
    fontSize: '13px',
    color: '#8892b0',
  },
  buttonGroup: {
    display: 'flex',
    gap: '10px',
    marginTop: '16px',
  },
  button: (variant, disabled) => ({
    flex: 1,
    padding: '16px',
    borderRadius: '14px',
    border: 'none',
    fontSize: '16px',
    fontWeight: '700',
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'all 0.2s',
    opacity: disabled ? 0.5 : 1,
    background:
      variant === 'primary' ? 'linear-gradient(135deg, #00d4aa, #00a896)' :
      variant === 'warning' ? 'linear-gradient(135deg, #ffc107, #ff9800)' :
      variant === 'danger' ? 'linear-gradient(135deg, #ff6b6b, #ee5253)' :
      'rgba(255,255,255,0.1)',
    color: variant === 'primary' || variant === 'warning' ? '#1a1a2e' : '#e6e6e6',
  }),
  toast: (type) => ({
    position: 'fixed',
    top: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    padding: '14px 28px',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: '600',
    zIndex: 1000,
    animation: 'slideDown 0.3s ease',
    boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
    background:
      type === 'success' ? '#00d4aa' :
      type === 'error' ? '#ff6b6b' :
      type === 'info' ? '#3498db' : '#ffc107',
    color: type === 'success' || type === 'warning' ? '#1a1a2e' : '#fff',
  }),
  emptyHint: {
    textAlign: 'center',
    color: '#8892b0',
    fontSize: '14px',
    marginTop: '8px',
  },
};

// 테스트 모드 활성화 여부 (환경 변수로 제어)
// 활성화하려면: REACT_APP_ENABLE_TEST_MODE=true
// 빌드 시: REACT_APP_ENABLE_TEST_MODE=true npm run build
const ENABLE_TEST_MODE = process.env.REACT_APP_ENABLE_TEST_MODE === 'true';

// 모드 정의
const MODES = {
  sit: {
    name: '앉아서 진행',
    modes: [
      { id: 'tv_reading', name: 'TV/독서', duration: 36 },
      { id: 'after_meal', name: '식사 후', duration: 18 },
      { id: 'rest', name: '휴식', duration: 18 },
      { id: 'neck_shoulder', name: '목/어깨 집중', duration: 18 },
      { id: 'back_waist', name: '등/허리 집중', duration: 18 },
      // 테스트용 30초 모드 - REACT_APP_ENABLE_TEST_MODE=true로 활성화
      ...(ENABLE_TEST_MODE ? [{ id: 'test_1min', name: '테스트 30초', duration: 0.5 }] : []),
    ],
  },
  lie: {
    name: '누워서 진행',
    modes: [
      { id: 'basic', name: '기본', duration: 36 },
      { id: 'circulation', name: '순환', duration: 36 },
      { id: 'fresh', name: '상쾌', duration: 36 },
      { id: 'special', name: '스페셜', duration: 90 },
      { id: 'stretch_quick', name: '스트레칭 퀵모드', duration: 18 },
      { id: 'recovery_quick', name: '피로회복 퀵모드', duration: 18 },
      // 테스트용 30초 모드 - REACT_APP_ENABLE_TEST_MODE=true로 활성화
      ...(ENABLE_TEST_MODE ? [{ id: 'test_1min', name: '테스트 30초', duration: 0.5 }] : []),
    ],
  },
};

const CLEANUP_MIN = 10;

function App() {
  const [socket, setSocket] = useState(null);
  const [connected, setConnected] = useState(false);
  const [state, setState] = useState({
    state: 'idle',
    serverTime: Date.now(),
    runningSession: null,
    isOwner: false,
    queue: [],
    queueCount: 0,
    nextTicket: null,
    myTicket: null,
    canStart: false,
    queueTimeoutRemainingMs: null, // 대기표 활성화 종료까지 남은 시간
  });
  const [posture, setPosture] = useState('sit');
  const [selectedMode, setSelectedMode] = useState(null);
  const [toast, setToast] = useState(null);
  const [displayTime, setDisplayTime] = useState('00:00');
  const [queueTimeoutDisplay, setQueueTimeoutDisplay] = useState('00:00');

  const serverTimeOffset = useRef(0);
  const prevState = useRef(null);
  const waitingForAvailable = useRef(false);
  const queueTimeoutStartTime = useRef(null);

  // 토스트 표시
  const showToast = useCallback((message, type = 'info') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  }, []);

  // 브라우저 알람 권한 요청
  const requestNotificationPermission = useCallback(async () => {
    if (!('Notification' in window)) {
      console.log('이 브라우저는 알림을 지원하지 않습니다.');
      return false;
    }

    if (Notification.permission === 'granted') {
      return true;
    }

    if (Notification.permission !== 'denied') {
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    }

    return false;
  }, []);

  // 알람 발생
  const showNotification = useCallback((title, body) => {
    if (Notification.permission === 'granted') {
      new Notification(title, {
        body,
        icon: '/favicon.ico',
        badge: '/favicon.ico',
        tag: 'ceragem-available',
        requireInteraction: false,
      });
    }
  }, []);

  // 소켓 연결
  useEffect(() => {
    const serverUrl =
      process.env.REACT_APP_SERVER_URL ||
      (window.location.hostname === 'localhost'
        ? 'http://localhost:8000'
        : window.location.origin);

    const newSocket = io(serverUrl, {
      withCredentials: true,
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: Infinity,
      timeout: 20000,
      forceNew: false,
      autoConnect: true
    });

    newSocket.on('connect', () => {
      setConnected(true);
      console.log('서버 연결됨');
    });

    newSocket.on('disconnect', () => {
      setConnected(false);
      console.log('서버 연결 해제');
    });

    newSocket.on('state:update', (newState) => {
      serverTimeOffset.current = Date.now() - newState.serverTime;
      
      // 이전 상태와 비교하여 알람 발생 조건 확인
      if (prevState.current) {
        const wasRunning = prevState.current.state === 'running';
        const isIdle = newState.state === 'idle';
        const canStart = newState.canStart && newState.myTicket;
        const prevCanStart = prevState.current.canStart && prevState.current.myTicket;
        const hasMyTicket = !!newState.myTicket;
        
        // 알람 발생 조건:
        // 1. 대기번호가 있고 (myTicket)
        // 2. 상태가 idle이고
        // 3. 시작할 수 있고 (canStart)
        // 4. 이전에는 시작할 수 없었거나 (prevCanStart === false), 사용중이었다가 idle로 변경된 경우
        
        if (isIdle && hasMyTicket && canStart) {
          // 이전에 시작할 수 없었거나, 사용중이었다가 idle로 변경된 경우 알람
          const shouldNotify = 
            (!prevCanStart && canStart) || // 시작할 수 없었는데 시작할 수 있게 됨
            (wasRunning && isIdle) || // 사용중이었다가 idle로 변경
            (waitingForAvailable.current); // 대기등록 후 알람 대기 중
          
          if (shouldNotify) {
            console.log('알람 발생 조건 충족:', {
              wasRunning,
              isIdle,
              canStart,
              prevCanStart,
              hasMyTicket,
              waitingForAvailable: waitingForAvailable.current
            });
            
            requestNotificationPermission().then((hasPermission) => {
              console.log('알람 권한:', hasPermission);
              if (hasPermission) {
                showNotification(
                  '사용 가능합니다!',
                  `대기번호 ${newState.myTicket}번 차례입니다. 지금 시작할 수 있습니다.`
                );
                showToast('사용 가능합니다! 지금 시작할 수 있습니다.', 'success');
                waitingForAvailable.current = false;
              } else {
                // 권한이 없어도 토스트는 표시
                showToast('사용 가능합니다! 지금 시작할 수 있습니다.', 'success');
                waitingForAvailable.current = false;
              }
            });
          }
        }
      }
      
      setState(newState);
      prevState.current = { ...newState };
      
      // 디버깅: 상태 업데이트 시 isOwner 확인
      if (newState.state === 'running') {
        console.log('상태 업데이트:', {
          state: newState.state,
          isOwner: newState.isOwner,
          myTicket: newState.myTicket
        });
      }
    });

    newSocket.on('toast:message', (data) => {
      showToast(data.message, data.type);
    });

    setSocket(newSocket);

    return () => {
      newSocket.close();
    };
  }, [showToast, requestNotificationPermission, showNotification]);

  // 타이머 업데이트
  useEffect(() => {
    if (state.state !== 'running' || !state.runningSession?.endTime) {
      setDisplayTime('00:00');
      return;
    }

    const updateTimer = () => {
      const now = Date.now() - serverTimeOffset.current;
      const remaining = Math.max(0, state.runningSession.endTime - now);

      const minutes = Math.floor(remaining / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      setDisplayTime(
        `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      );
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [state.state, state.runningSession?.endTime]);

  // 대기표 활성화 타이머 업데이트
  useEffect(() => {
    if (!state.queueTimeoutRemainingMs || !state.canStart || !state.myTicket) {
      setQueueTimeoutDisplay('');
      queueTimeoutStartTime.current = null;
      return;
    }

    // 서버에서 받은 남은 시간을 기준으로 시작 시간 기록 (한 번만)
    if (!queueTimeoutStartTime.current || prevState.current?.queueTimeoutRemainingMs !== state.queueTimeoutRemainingMs) {
      queueTimeoutStartTime.current = Date.now();
    }

    const updateQueueTimer = () => {
      if (!queueTimeoutStartTime.current) return;
      
      // 서버에서 받은 남은 시간에서 경과 시간을 빼서 계산
      const elapsed = Date.now() - queueTimeoutStartTime.current;
      const remaining = Math.max(0, state.queueTimeoutRemainingMs - elapsed);

      const minutes = Math.floor(remaining / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      setQueueTimeoutDisplay(
        `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      );
    };

    updateQueueTimer();
    const interval = setInterval(updateQueueTimer, 1000);

    return () => clearInterval(interval);
  }, [state.queueTimeoutRemainingMs, state.canStart, state.myTicket]);

  // 번호표 발급
  const handleIssueTicket = useCallback(() => {
    if (!socket) return;
    
    // 알람 권한 요청
    requestNotificationPermission();
    
    socket.emit('ticket:issue', (result) => {
      if (result.success) {
        showToast(result.message, 'success');
        // 대기등록 성공 시 알람 대기 상태로 설정
        // 현재 사용중이거나, 대기열에 있으면 알람 대기
        if (state.state === 'running' || (state.state === 'idle' && !state.canStart)) {
          waitingForAvailable.current = true;
        }
      } else {
        showToast(result.error, 'error');
      }
    });
  }, [socket, showToast, state.state, requestNotificationPermission]);

  // 대기 취소
  const handleCancelTicket = useCallback(() => {
    if (!socket) return;
    socket.emit('ticket:cancel', (result) => {
      if (result.success) {
        showToast(result.message, 'success');
        // 대기 취소 시 알람 대기 상태 해제
        waitingForAvailable.current = false;
      } else {
        showToast(result.error, 'error');
      }
    });
  }, [socket, showToast]);

  // 세션 시작
  const handleStart = useCallback(() => {
    if (!socket || !selectedMode) {
      showToast('모드를 선택해주세요.', 'error');
      return;
    }
    
    // 세션 시작 시 알람 대기 상태 해제
    waitingForAvailable.current = false;
    socket.emit('session:start', { posture, modeId: selectedMode.id }, (result) => {
      if (result.success) {
        showToast('세션이 시작되었습니다!', 'success');
        setSelectedMode(null);
      } else {
        showToast(result.error, 'error');
      }
    });
  }, [socket, posture, selectedMode, showToast]);

  // 세션 중간 취소
  const handleCancelSession = useCallback(() => {
    if (!socket) return;
    if (!window.confirm('정말 세션을 취소하시겠습니까?')) return;

    socket.emit('session:cancel', (result) => {
      if (result.success) {
        showToast('세션이 취소되었습니다.', 'success');
      } else {
        showToast(result.error, 'error');
      }
    });
  }, [socket, showToast]);

  // 시작 가능 여부
  const canStartNow = state.canStart && selectedMode && state.state === 'idle';

  // 내 차례 여부
  const isMyTurn =
    state.myTicket &&
    state.nextTicket === state.myTicket &&
    state.state === 'idle';

  // 현재 모드 목록
  const currentModes = MODES[posture]?.modes || [];

  return (
    <div style={styles.container}>
      {/* 토스트 */}
      {toast && <div style={styles.toast(toast.type)}>{toast.message}</div>}

      {/* 헤더 */}
      <header style={styles.header}>
        <div style={styles.logo}>그로윈 세라젬</div>
        <div style={styles.subtitle}>
          예약 시스템
          {!connected && <span style={{ color: '#ff6b6b' }}> (연결 중...)</span>}
        </div>
      </header>

      {/* 현재 상태 */}
      <div style={styles.statusCard}>
        <div style={styles.statusBadge(state.state === 'running')}>
          {state.state === 'running' ? '🔴 사용중' : '🟢 사용가능'}
        </div>
        {state.state === 'running' && state.runningSession && (
          <div style={styles.runningInfo}>
            {state.runningSession.posture === 'sit' ? '앉아서' : '누워서'} -{' '}
            {state.runningSession.modeName}
          </div>
        )}
      </div>

      {/* 타이머 (Running 상태) */}
      {state.state === 'running' && (
        <div style={styles.timerCard}>
          <div style={styles.timerLabel}>남은 시간</div>
          <div style={styles.timer}>{displayTime}</div>
          {state.isOwner && (
            <button style={styles.cancelBtn} onClick={handleCancelSession}>
              중간 취소
            </button>
          )}
        </div>
      )}

      {/* 대기열 정보 */}
      <div style={styles.queueCard}>
        <div style={styles.queueHeader}>
          <span style={styles.queueTitle}>대기 현황</span>
          <span style={styles.queueCount}>대기 인원: {state.queueCount}명</span>
        </div>
        <div style={styles.queueGrid}>
          <div style={styles.queueItem}>
            <div style={styles.queueLabel}>다음 대기</div>
            <div style={styles.queueValue}>
              {state.nextTicket ? `${state.nextTicket}번` : '-'}
            </div>
          </div>
          <div style={styles.queueItem}>
            <div style={styles.queueLabel}>전체 대기</div>
            <div style={styles.queueValue}>{state.queueCount}명</div>
          </div>
        </div>
      </div>

      {/* 내 대기번호 */}
      {state.myTicket && (
        <div style={styles.myTicketCard}>
          <div style={styles.myTicketLabel}>내 대기번호</div>
          <div style={styles.myTicketNumber}>{state.myTicket}번</div>
          {isMyTurn && (
            <>
              <div style={styles.myTicketHint}>지금 시작할 수 있습니다!</div>
              {queueTimeoutDisplay && (
                <div style={styles.queueTimeoutTimer}>
                  ⏰ 활성화 종료까지: {queueTimeoutDisplay}
                </div>
              )}
            </>
          )}
        </div>
      )}

      {/* 내 차례 안내 */}
      {isMyTurn && (
        <div style={styles.turnNotice}>
          <div style={styles.turnNoticeText}>
            🎉 대기번호 {state.myTicket}번 차례입니다!
            <br />
            모드를 선택하고 시작 버튼을 눌러주세요.
            {queueTimeoutDisplay && (
              <>
                <br />
                <span style={{ color: '#ffc107', fontWeight: '700' }}>
                  ⏰ 활성화 종료까지: {queueTimeoutDisplay}
                </span>
              </>
            )}
          </div>
        </div>
      )}

      {/* 모드 선택 (Idle 상태에서만) */}
      {state.state === 'idle' && (
        <div style={styles.modeSection}>
          <div style={styles.sectionTitle}>진행 방식 선택</div>

          {/* 자세 선택 탭 */}
          <div style={styles.postureTabs}>
            <button
              style={styles.postureTab(posture === 'sit')}
              onClick={() => {
                setPosture('sit');
                setSelectedMode(null);
              }}
            >
              앉아서 진행
            </button>
            <button
              style={styles.postureTab(posture === 'lie')}
              onClick={() => {
                setPosture('lie');
                setSelectedMode(null);
              }}
            >
              누워서 진행
            </button>
          </div>

          {/* 모드 목록 */}
          <div style={styles.modeList}>
            {currentModes.map((mode) => (
              <div
                key={mode.id}
                style={styles.modeItem(selectedMode?.id === mode.id)}
                onClick={() => setSelectedMode(mode)}
              >
                <span style={styles.modeName}>{mode.name}</span>
                <span style={styles.modeDuration}>
                  {mode.id === 'test_1min' 
                    ? `${mode.duration * 60}초` 
                    : `${mode.duration + CLEANUP_MIN}분`}
                </span>
              </div>
            ))}
          </div>

          {/* 시작 버튼 */}
          <div style={styles.buttonGroup}>
            <button
              style={styles.button('primary', !canStartNow)}
              disabled={!canStartNow}
              onClick={handleStart}
            >
              시작
            </button>
          </div>

          {/* 시작 불가 안내 */}
          {state.queueCount > 0 && !state.canStart && (
            <div style={styles.emptyHint}>
              대기번호 {state.nextTicket}번의 차례입니다.
            </div>
          )}
        </div>
      )}

      {/* 대기 등록/취소 버튼 (항상 표시) */}
      <div style={styles.buttonGroup}>
        {!state.myTicket ? (
          <button
            style={styles.button('warning', false)}
            onClick={handleIssueTicket}
          >
            대기 등록 (번호표 발급)
          </button>
        ) : (
          <button style={styles.button('danger', false)} onClick={handleCancelTicket}>
            대기 취소 ({state.myTicket}번)
          </button>
        )}
      </div>

      {/* 대기열 비어있고 idle 상태일 때 안내 */}
      {state.state === 'idle' && state.queueCount === 0 && (
        <div style={styles.emptyHint}>
          현재 대기자가 없습니다. 바로 시작하세요!
        </div>
      )}

      {/* CSS 애니메이션 */}
      <style>{`
        @keyframes slideDown {
          from { opacity: 0; transform: translate(-50%, -20px); }
          to { opacity: 1; transform: translate(-50%, 0); }
        }
        @keyframes pulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(0, 212, 170, 0.4); }
          50% { box-shadow: 0 0 0 12px rgba(0, 212, 170, 0); }
        }
        * { box-sizing: border-box; }
        body { margin: 0; background: #1a1a2e; }
      `}</style>
    </div>
  );
}

export default App;
